import {Component, OnDestroy, OnInit} from '@angular/core';
import {AgentActiveObjectDto} from "../../../model/dto/entity/agent-active-object.dto";
import {Subscription} from "rxjs";
import {AgentActiveObjectService} from "../../../service/api/agent-active-object.service";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {
    MvsObjectNavigationProviderGeneric
} from "../../../../../core/shared/navigation/impl/mvs-object-navigation-provider-generic";
import {MvsObjectNavigationEntry} from "../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {MvsObjectNavigationActionEnum} from "../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {MvsObjectService} from "../../../../../core/shared/service/object/mvs-object.service";
import {ObjectChangeInformationActionEnum} from "../../../../../core/shared/logic/object-change-information";

@Component({
    selector: 'am-agent-main-active-objects',
    templateUrl: './am-agent-main-active-objects.component.html',
    standalone: false
})
export class AmAgentMainActiveObjectsComponent implements OnInit, OnDestroy {

    mainObject: AgentActiveObjectDto;
    activeObjectsSubscription: Subscription;
    objectTypeSubscription: Subscription;

    constructor(
        protected navigationService: MvsObjectNavigationService,
        protected coreService: MvsCoreService,
        protected objectService: MvsObjectService,
        protected agentActiveObjectService: AgentActiveObjectService) {

    }

    ngOnInit(): void {
        this.navigationService.setNavigationProvider(new MvsObjectNavigationProviderGeneric());

        this.activeObjectsSubscription = this.agentActiveObjectService.subjectAgentActiveObjects.subscribe(value => {
            const mainObject = value?.find(item => item.mainObject == true);
            if (mainObject && this.mainObject?.id != mainObject.id) {
                this.mainObject = mainObject;
                this.getMainObjectInfo();
            } else if (!mainObject) {
                this.mainObject = null;
            }
        });

        this.objectTypeSubscription = this.objectService.objectChangeEvent.subscribe(event => {
            if (event.objectType == this.mainObject?.objectTypeDto.alias && event.after.id == this.mainObject.objectId) {
                if (event.action == ObjectChangeInformationActionEnum.deleted) {
                    this.mainObject = null;
                } else {
                    this.getMainObjectInfo();
                }
            }
        })
    }

    getMainObjectInfo() {
        const alias = this.mainObject.objectTypeDto.alias;

        const crudService = this.coreService.getCrudService(alias);

        crudService.get(this.mainObject.objectId,null,false,false,0).subscribe(res => {
            this.mainObject.objectDto = res;
        });

    }

    /**
     * open sidebar to show selected object
     * @param object
     */
    openObjectDrawer(object: AgentActiveObjectDto) {
        const mvsObjectNavigationEntry = MvsObjectNavigationEntry.createNavigationEntry(object.objectTypeDto.alias, object.objectId, null, "Object", null, null, MvsObjectNavigationActionEnum.any);
        this.navigationService.navigateTo(mvsObjectNavigationEntry, 'right');
    }

    /**
     * remove object as main object
     * @param object
     */
    removeActiveMainObject(object: AgentActiveObjectDto) {
        this.agentActiveObjectService.completeMainObject(object.id);
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {
        this.activeObjectsSubscription.unsubscribe();

        if (this.objectTypeSubscription) {
            this.objectTypeSubscription.unsubscribe();
        }

    }

}
